import React from "react";
import { FaTimes, FaCrown } from "react-icons/fa";

const ImageModelModal = ({
  isOpen,
  onClose,
  mode,
  setMode,
  disablePremium = false,
  isPreview = false,
  className = ""
}) => {
  if (!isOpen && !isPreview) return null;
  
  const options = [
    { id: 'free', label: 'Free', icon: '🆓', description: 'Free mode for quick drafts' },
    { id: 'standard', label: 'Standard', icon: '⚙️', description: 'Balanced quality and speed' },
    { id: 'premium', label: 'Premium', icon: '💎', description: 'Highest quality, more control' }
  ];

  const Panel = (
    <div className="glass-effect rounded-2xl border border-white/10 bg-[#111111]/95 backdrop-blur-2xl p-4 w-72 sm:w-80">
      <div className="flex items-center gap-2 mb-3">
        <FaCrown className="text-amber-300/90 text-xs" />
        <h3 className="text-xs font-medium text-white">Mode</h3>
        {!isPreview && (
          <button type="button" className="ml-auto text-gray-300 hover:text-white" onClick={onClose}>
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      <div className="space-y-2">
        {options.map(option => {
          const isPremium = option.id === 'premium';
          const isDisabled = isPremium && disablePremium;
          return (
            <div key={option.id} className="flex flex-col items-start">
              <button
                type="button"
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg border text-[11px] transition-all ${
                  isDisabled
                    ? 'bg-gray-800/30 text-gray-500 border-gray-700/40 cursor-not-allowed opacity-50'
                    : (mode === option.id 
                        ? 'bg-white/10 text-white border-white/20' 
                        : 'text-gray-300 border-gray-600/40 hover:border-gray-500/60 hover:bg-white/5')
                }`}
                onClick={() => { if (!isDisabled) { setMode(option.id); if (!isPreview) onClose(); } }}
                title={isDisabled ? 'Insufficient credits' : option.description}
                disabled={isDisabled}
              >
                <span className="text-lg">{option.icon}</span>
                <div className="flex-1 text-left">
                  <div className="font-medium">{option.label}</div>
                </div>
                {mode === option.id && !isDisabled && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );

  if (isPreview) return <div className={`absolute z-50 pointer-events-auto ${className}`}>{Panel}</div>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      {Panel}
    </div>
  );
};

export default ImageModelModal;


